// import LanguageSelect from "@/components/Language/LanguageSelect";
import PageBack from "@/components/PageBack";
import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import mobileClasses from './mobile.module.css';
import RpIcon from "@/components/RpIcon";
import MobileLanguageSelector from "@/pages/components/MobileLanguageSelector";
import {useBoolean} from "ahooks";

const LoginHeader = () => {
  // const {isMobile} = useWindowSize();
  const navigate = useNavigate()
  const location = useLocation()
  const {t} = useTranslation()
  const { settings } = useSettings();
  const [isLanguageSelectorOpen, languageSelectorOperate] = useBoolean(false);
  return (<>
    {/* {isMobile && */}
        <Stack className={mobileClasses.root} direction="row" alignItems="center" justifyContent={'space-between'}>
          <Stack direction={'row'}>
            {location.pathname != RouteConstant.LOGIN && <div style={{ paddingRight: '16px' }}>
              <PageBack onClick={() => {
                navigate(-1)
              }}/>
            </div>}
            {/* <img alt="" src={`/images/logo-${settings.theme}.svg`}/> */}
            <img alt="" style={{height:"30px"}} src={`/images/logo-sonic-dark.svg`}/>
          </Stack>
          <RpIcon icon="lang" clickable size={22} onClick={() => {languageSelectorOperate.setTrue()}}/>
        </Stack>
        {/* } */}
        <MobileLanguageSelector
          open={isLanguageSelectorOpen}
          onClose={languageSelectorOperate.setFalse}
        />
  </>)
}

export default LoginHeader;